<template>
  <div>
    <div class="toast" v-show="toastShow">
      <div>
        <div @click="closeToast">X</div>
        <span>
          <div class="toastText">{{ toastText }}</div>
          <div v-show="toastBtnShow">
            <button id="confirm" class="button btnSmall">Confirm</button>
            <button class="button btnSmall" @click="closeToast">Cancel</button>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Toast",
  data() {
    return {
      toastShow: false,
      toastText: "",
      toastBtnShow: false,
      toastBtnCmd: "",
    };
  },
  methods: {
    showToast(text, time = 0, btnFun = null, ...btnFunParams) {
      this.toastText = text;
      this.toastShow = true;
      if (btnFun != null) {
        this.toastBtnShow = true;
        document.querySelector("#confirm").onclick = function () {
          btnFun(...btnFunParams);
        };
      }

      if (time > 0) {
        setTimeout(() => {
          this.toastShow = false;
          this.toastText = "";
        }, time * 1000);
      }
    },
    toastRun(fun, params) {
      fun(params);
    },
    closeToast() {
      this.toastShow = false;
      this.toastText = "";
    },
  },
};
</script>
<style scoped>
.toast {
  position: fixed;
  z-index: 2000;
  max-width: 600px;
  top: 50px;
  left: 50%;
  transition: all 0.5s;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: rgba(0, 141, 216, 1);
  padding: 10px;
}
.toast > div {
  position: relative;
}
.toast > div > div {
  line-height: 19px;
  height: 22px;
  width: 22px;
  border-radius: 11px;
  top: -21px;
  right: -21px;
  position: absolute;
  background: rgba(0, 141, 216, 1);
  border: 0.1rem solid white;
  cursor: pointer;
}
.toastText {
  padding: 5px;
}
.btnSmall {
  width: 100px;
  height: 30px;
  padding: 0;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Toast.vue